module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tunetooShop"
    }
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "height": "1453",
      "src": "https://chaperon.tunetoo.com",
      "frameborder": "0"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n      Site en partenariat avec tunetoo spécialite de la  "), _c('a', {
    attrs: {
      "href": "https://www.tunetoo.com/coque-personnalisee.php",
      "target": "_blank"
    }
  }, [_vm._v("Coque de téléphone personnalisée")]), _vm._v(".\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22998796"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shop.vue
// module id = 31
// module chunks = 0